/************
 * Model Class
 * File Name ...: med-search-structure.components.ts
 * Generated By : ianday on 4/14/25
 * Date ........: 4/14/25
 /************/
import {ValidationResult} from './validation-result';

export class MedSearchStructure {
    public ndcNumber: string;
    public medDescription: string;

    constructor(ndc: string, description: string) {
        this.ndcNumber = ndc;
        this.medDescription = description;
    }
    public setAll(): void {
        if (this.ndcNumber.length === 0) {
            this.ndcNumber = 'ALL';
        }
        if (this.medDescription.length === 0) {
            this.medDescription = 'ALL';
        }
    }

}
